export const QUIZ_LIST_REQUEST = 'QUIZ_LIST_REQUEST'
export const QUIZ_LIST_SUCCESS = 'QUIZ_LIST_SUCCESS'
export const QUIZ_LIST_FAILURE = 'QUIZ_LIST_FAILURE'

export const QUIZ_UPDATE_REQUEST = 'QUIZ_UPDATE_REQUEST'
export const QUIZ_UPDATE_SUCCESS = 'QUIZ_UPDATE_SUCCESS'
export const QUIZ_UPDATE_FAILURE = 'QUIZ_UPDATE_FAILURE'